/**
 * @fileoverview POST handler for the "/internal_user_groups/remove_test_users_from_internal_user_group" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appSettingsInternalUserGroupsRemoveTestUsersFromInternalUserGroupCacheKeys } from "./constants";
import type {
  PostAppSettingsInternalUserGroupsRemoveTestUsersFromInternalUserGroupProps,
  AppSettingsInternalUserGroupsRemoveTestUsersFromInternalUserGroupResult,
} from "./types";

export const postAppSettingsInternalUserGroupsRemoveTestUsersFromInternalUserGroup = reactQueryMutationAdapter(
  appSettingsInternalUserGroupsRemoveTestUsersFromInternalUserGroupCacheKeys,
  (
    props: PostAppSettingsInternalUserGroupsRemoveTestUsersFromInternalUserGroupProps
  ): Promise<AppSettingsInternalUserGroupsRemoveTestUsersFromInternalUserGroupResult> => {
    const body = {
      test_user_ids: props.testUserIds,
      internal_user_group_id: props.internalUserGroupId,
    };

    return fetch("/internal_user_groups/remove_test_users_from_internal_user_group", "POST", body);
  }
);
